"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _require = require('../utils/url'),
    getURL = _require.getURL;

var axios = require('axios');

var _require2 = require('../utils/async'),
    getAsyncQueue = _require2.getAsyncQueue,
    clearAsyncQueues = _require2.clearAsyncQueues;

function getAPINamespace(_ref) {
  var url = _ref.url;
  url = getURL(url);
  var _url = url,
      hostname = _url.hostname,
      pathname = _url.pathname; // grab any modifier that looks like `/v{n}/` and use it to make a different namespace

  var namespaceModifier = pathname.match(/^\/v(\d|\.)*\//);
  return "".concat(hostname).concat(namespaceModifier ? namespaceModifier[0] : '');
}

function enqueueRequest(config) {
  return new Promise(function (resolve, reject) {
    try {
      var namespace = getAPINamespace(config);
      var queue = getAsyncQueue({
        namespace: namespace
      });
      queue.emit('add', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios(config);

              case 3:
                response = _context.sent;
                resolve(response);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      })));
    } catch (err) {
      console.error(err);
      reject(err);
    }
  });
}

function clearQueues() {
  clearAsyncQueues.apply(null, arguments);
}

module.exports = {
  getAPINamespace: getAPINamespace,
  enqueueRequest: enqueueRequest,
  clearQueues: clearQueues
};